import { Link } from "react-router-dom";
import { Home, Sparkles } from "lucide-react";

export default function NotFoundPage() {
    return (
        <div data-testid="not-found-page" className="min-h-[70vh] grid place-items-center px-6 py-20" style={{ background: "var(--bg)" }}>
            <div className="max-w-xl text-center">
                <p className="font-mono-dm text-[10px] tracking-[0.3em] uppercase" style={{ color: "var(--rose-deep)" }}>Error 404</p>
                <h1 className="font-display text-7xl md:text-8xl mt-3 leading-none" style={{ color: "var(--text)" }}>
                    404
                </h1>
                <p className="font-script text-3xl mt-2" style={{ color: "var(--rose-deep)" }}>
                    Deze pagina is van de muur gevallen.
                </p>
                <p className="mt-5 text-sm" style={{ color: "var(--text-2)" }}>
                    Geen probleem — er zijn nog veel andere mooie stickers en tegeltjes te ontdekken.
                </p>
                <div className="mt-8 flex gap-3 justify-center flex-wrap">
                    <Link to="/" className="btn-rose" data-testid="nf-home"><Home size={14} /> Naar de winkel</Link>
                    <Link to="/stickers" className="btn-ghost" data-testid="nf-stickers"><Sparkles size={14} /> Bekijk stickers</Link>
                </div>
            </div>
        </div>
    );
}
